import script from "./WidgetQuickAddButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./WidgetQuickAddButton.vue?vue&type=script&lang=ts&setup=true"

import "./WidgetQuickAddButton.vue?vue&type=style&index=0&id=5ccd80c3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ccd80c3"]])

export default __exports__